import Chart from 'chart.js/auto';
import def_day_lines from './graph_utils.js';

const suggestedMax = 50.;

export default function graph_wind(ser,dates,ff){
  var module = new Array(ff.length);
  var rafale = new Array(ff.length);
  var direction = new Array(ff.length);
  var ann = new Array(ff.length);
  const knams =  0.514791
  for(let i=0; i < ff.length; i++){
    module[i]=ff[i][0]/knams;
    if(ff[i][1]){
      rafale[i]=ff[i][1]/knams;
      if(rafale[i]-module[i] < .1){
	rafale[i]=null;
      }
    }else{
      rafale[i]=null;
    }
    direction[i]=ff[i][2];
  }
  const data = {
    labels: dates,
    datasets: [
      {
	label: 'Force',
	data: module,
	borderColor: 'rgb(100, 100, 192)',
	lineTension: 0.3
      },
      {
	label: 'Rafale',
	data: rafale,
	borderColor: 'rgb(192, 50, 50)',
	lineTension: 0.3
      }
    ]
  };
  
  const ctx = document.getElementById('id_series_canvas');
  if(ser.chart){
    ser.chart.destroy();
  }
  ser.chart = new Chart(ctx, {
    type: 'line',
    data: data,
    options: {
      animations: false,
      responsive: true,
      title: {
	display: true,
	text: 'Chart.js Time Scale'
      },
      scales: {
	y: {
	  title: {
	    display: true,
	    text: '[Noeuds]'
	  },		    
	  min: 0 ,
	  suggestedMax: suggestedMax
	}
      },
      plugins: {
	zoom: {
	  zoom: {
	    wheel: {
	      enabled: true
	    },
	    pinch: {
	      enabled: true
	    },
	    mode: "x",
	    speed: 100				    
	  },
	  pan: {
	    enabled: true,
	    mode: "x",
	    speed: 100
	  }
	}
      }
    }
  });
  
  // Add wind direction via text annotation
  // Not need to repete the above option
  // there must be a better way to do this...
  for(var i=0; i < ff.length; i++){
    console.log(dates[i])
    ann[i]={
      type: 'label',
      color: 'grey',
      xValue: i,
      yValue: .95*suggestedMax,
      content: ['\u2799'],
      rotation: direction[i]-270,
      font: {
        size: 28
      }
    }
  }

  def_day_lines(dates,ann);
  
  ser.chart.options = {
    maintainAspectRatio: false,
    animations: false,	
    responsive: true,
    title: {
      display: true,
      text: 'Chart.js Time Scale'
    },
    scales: {
      y: {
	title: {
	  display: true,
	  text: '[Noeuds]'
	},		    
	min: 0 ,
	suggestedMax: 50,
      }
    },
    plugins: {
      annotation: {
	annotations: ann
      },
      zoom: {
	zoom: {
	  wheel: {
	    enabled: true
	  },
	  pinch: {
	    enabled: true
	  },
	  mode: "x",
	  speed: 100				    
	},
	pan: {
	  enabled: true,
	  mode: "x",
	  speed: 100
	}
      }
    }
  };
  ser.chart.update();
}
